import React, { Fragment, Component } from "react";
import { getMenuData } from "common/menu";
import logo from "assets/logo.svg";
import { Layout, Icon, Alert } from "antd";
import GlobalHeader from "components/GlobalHeader";
import GlobalFooter from "components/GlobalFooter";
import SiderMenu from "components/SiderMenu";
import DocumentTitle from "react-document-title";
import classNames from "classnames";
import { ContainerQuery } from "react-container-query";
import { enquireScreen } from "enquire-js";
import { inject } from "mobx-react";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { routerStateToUrl, RouterState } from "mobx-state-router";

const { Content, Header, Footer } = Layout;

const query = {
	"screen-xs": {
		maxWidth: 575
	},
	"screen-sm": {
		minWidth: 576,
		maxWidth: 767
	},
	"screen-md": {
		minWidth: 768,
		maxWidth: 991
	},
	"screen-lg": {
		minWidth: 992,
		maxWidth: 1199
	},
	"screen-xl": {
		minWidth: 1200
	}
};

let isMobile;
enquireScreen(b => {
	isMobile = b;
});

@inject("rootStore")
@observer
export default class BasicLayout extends Component {
	constructor(props) {
		super(props);
		this.state = {
			// collapsed: false,
			isMobile
		};
	}

	componentDidMount() {
		enquireScreen(mobile => {
			this.setState({
				isMobile: mobile
			});
		});

		// const {
		// 	rootStore: { userStore }
		// } = this.props;
		// userStore.fetchCurrentUser();
		// this.props.dispatch({
		//   type: "user/fetchCurrent"
		// });
	}

	handleMenuCollapse = collapsed => {
		const {
			rootStore: { uiStore }
		} = this.props;
		// this.setState({
		// 	collapsed: collapsed
		// });
		// console.log("Call handle menu collapse " + collapsed);
		uiStore.setCollapsed(collapsed);
	};

	handleMenuClick = ({ key }) => {
		const {
			rootStore: { userStore, routerStore }
		} = this.props;
		if (key == "logout") {
			userStore.remoteLogout();
			return;
		}
		if (key == "options") {
			// console.log(routerStateToUrl(routerStore, new RouterState("options")));
		}
		//Do nothing
	};

	getPageTitle = () => {
		return "RankerX";
	};

	render() {
		const {
			rootStore: { userStore, uiStore }
		} = this.props;
		
		const collapsed = uiStore.collapsed;

		// console.log("Basic layout rendered " + collapsed);

		const layout = (
			<Layout>
				<SiderMenu
					logo={logo}
					// 不带Authorized参数的情况下如果没有权限,会强制跳到403界面
					// If you do not have the Authorized parameter
					// you will be forced to jump to the 403 interface without permission
					menuData={getMenuData()}
					collapsed={collapsed}
					isMobile={false}
					onCollapse={this.handleMenuCollapse}
				/>
				<Layout>
					{/* <Alert
						message="There is a new update. Please update the program ASAP."
						type="success"
						banner
					/> */}
					<Header style={{ padding: 0 }}>
						<GlobalHeader
							logo={logo}
							currentUser={userStore.currentUser}
							collapsed={collapsed}
							isMobile={this.state.isMobile}
							onCollapse={this.handleMenuCollapse}
							onMenuClick={this.handleMenuClick}
						/>
					</Header>
					<Content style={{ margin: "24px 24px 0", height: "100%" }}>
						{this.props.children}
					</Content>
					<Footer style={{ padding: 0 }}>
						<GlobalFooter
							links={[
								{
									key: "RankerX",
									title: "RankerX",
									href: "https://rankerx.com",
									blankTarget: true
								},
								{
									key: "Ant Design",
									title: "Ant Design",
									href: "http://ant.design",
									blankTarget: true
								}
							]}
							copyright={
								<Fragment>
									Copyright <Icon type="copyright" /> 2018 RankerX Pty Ltd.
								</Fragment>
							}
						/>
					</Footer>
				</Layout>
			</Layout>
		);
		return (
			<DocumentTitle title={this.getPageTitle()}>
				<ContainerQuery query={query}>
					{
						params => {
							// console.log(params);
							return <div className={classNames(params)}>{layout}</div>
							
						}					
					}
				</ContainerQuery>
			</DocumentTitle>
		);
	}
}
